import React, { useEffect } from 'react';
import { firestore } from '../firebase';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, List, ListItem, ListItemText, Grid } from '@material-ui/core';
import numeral from 'numeral'
import axios from 'axios';

const addresses = ['1 Material-UI Drive', 'Reactville', 'Anytown', '99999', 'USA'];

const useStyles = makeStyles(theme => ({
	listItem: {
		padding: theme.spacing(1, 0),
	},
	total: {
		fontWeight: '700',
	},
	title: {
		marginTop: theme.spacing(2),
	},
}));

export default function Review(props) {
	const classes = useStyles();
	const {data} = props

	useEffect(() => {
		if (data) {
			console.log(data)
			if (!data.emailSended) {
				axios.get('https://us-central1-teampower-11e55.cloudfunctions.net/sendWorkshopConfirm', {
					params: { data }
				}).then(response => {
					firestore.collection('transactions').doc(data.id).update({ emailSended: true })
				}).catch(error => {
					console.log(error)
				})
			} else {
				console.log('No se mandó')
			}
		}
	},[data.id])

	return (
		<React.Fragment>
			<Typography variant="h6" gutterBottom>
				Detalle de Órden
			</Typography>
			<List disablePadding>
				<ListItem className={classes.listItem}>
					<ListItemText primary="Competencias y ALGO MÁS que hacen a un COACH PROFESIONAL" secondary="Inscripción a workshop" />
					<Typography variant="body2">{data.amount}</Typography>
				</ListItem>
				<ListItem className={classes.listItem}>
					<ListItemText primary="Total" />
					<Typography variant="subtitle1" className={classes.total}>
						{numeral(data.amount).format('$0,0.00')} USD
					</Typography>
				</ListItem>
			</List>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<Typography variant="h6" gutterBottom className={classes.title}>
						Estatus de Pago
					</Typography>
					<Typography gutterBottom>{data.paymentStatus === 'success' ? 'Pagado' : data.paymentStatus === 'error' ? 'Error al realizar pago' : 'Procesando pago'}</Typography>
					<Typography gutterBottom>¿Tienes dudas? Contáctanos a contacto@team-power.com.mx o con Esther Rodriguez al +34 647 28 6110.</Typography>
				</Grid>
				<Grid item container direction="column" xs={12} sm={6}>
					<Typography variant="h6" gutterBottom className={classes.title}>
						Datos de Usuario
					</Typography>
					<Typography gutterBottom>{data.name} {data.last_name}</Typography>
					<Typography gutterBottom>{data.phone}</Typography>
					<Typography gutterBottom>{data.email}</Typography>
				</Grid>
			</Grid>
		</React.Fragment>
	);
}